import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

/**
 * QRCode Component
 * Generates QR code from URL using Canvas API
 * Uses qr.js library via CDN or generates QR code with online service
 */
const QRCode = ({ value, size = 150, style = {} }) => {
  const canvasRef = useRef(null);
  const [qrImageUrl, setQrImageUrl] = useState(null);

  useEffect(() => {
    if (!value) return;

    // Use QR code API service (no external dependencies needed)
    // This generates a QR code image URL
    const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}`;
    setQrImageUrl(qrApiUrl);

    // Alternative: Generate QR code using canvas (if we want to avoid external API)
    // For now, we'll use the API service for simplicity
  }, [value, size]);

  if (!value) return null;

  return (
    <Box sx={{ display: 'inline-block', ...style }}>
      {qrImageUrl ? (
        <img
          src={qrImageUrl}
          alt="QR Code"
          style={{
            width: size,
            height: size,
            display: 'block'
          }}
        />
      ) : (
        <Box
          sx={{
            width: size,
            height: size,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #ddd',
            backgroundColor: '#f5f5f5'
          }}
        >
          Loading QR...
        </Box>
      )}
    </Box>
  );
};

export default QRCode;

